import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, Drawer, Stack } from '@mui/material';
import { getUserSelector } from '@store/auth';
import { useDeviceSize } from '@hooks';
import { Routes } from '@enums';
import { externalMobileMenuItems, menuItems, onAuthClick } from '@components/header/header.helpers';
import { MenuButton } from '@components/header/header.styles';
import { Icon, IconButton, Typography } from '@elements';
import { colors } from '@themes';
import { StyledLink } from './drawer.styles';
import Close from '@images/close.svg';
import right from '@assets/images/chevron-right.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DrawerComponent = function DrawerComponent(_ref) {
  var open = _ref.open,
      toggleDrawer = _ref.toggleDrawer,
      goToRoute = _ref.goToRoute,
      isRouteActive = _ref.isRouteActive;

  var _useDeviceSize = useDeviceSize(),
      mobile = _useDeviceSize.mobile,
      tablet = _useDeviceSize.tablet;

  var user = useSelector(getUserSelector);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Drawer, {
    anchor: tablet ? 'left' : 'bottom',
    open: open,
    onClose: toggleDrawer,
    sx: {
      '& .MuiDrawer-paper': {
        backgroundColor: colors.mineShaft,
        boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.25)',
        padding: '8px 20px',
        width: tablet ? '332px' : mobile ? '100%' : 'auto',
        height: '100%'
      }
    },
    ModalProps: {
      BackdropProps: {
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.60)',
          backdropFilter: 'blur(10px)'
        }
      }
    },
    children: [/*#__PURE__*/_jsx(Box, {
      position: "absolute",
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: toggleDrawer,
        size: "large",
        children: /*#__PURE__*/_jsx(Icon, {
          src: Close,
          width: 28,
          height: 28
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      pt: mobile ? 3 : 10,
      pl: 7.5,
      pr: mobile ? 2.5 : 7.5,
      children: [/*#__PURE__*/_jsx(Stack, {
        gap: 1,
        alignItems: "flex-start",
        children: menuItems.filter(function (item) {
          return item.route !== Routes.Shop;
        }).map(function (menuItem) {
          return /*#__PURE__*/_jsx(MenuButton, {
            onClick: goToRoute(menuItem.route, menuItem === null || menuItem === void 0 ? void 0 : menuItem.isExternal),
            variant: "text",
            active: isRouteActive(menuItem.route),
            $color: isRouteActive(menuItem.route) ? 'internationalOrange' : 'secondarySilver',
            children: /*#__PURE__*/_jsx(Typography, {
              fontSize: "30px",
              lineHeight: "28px",
              letterSpacing: "0.6px",
              fontWeight: 500,
              children: menuItem.label
            })
          }, menuItem.route);
        })
      }), /*#__PURE__*/_jsx(Stack, {
        gap: 1.5,
        pt: mobile ? 2.2 : 11,
        alignItems: "flex-start",
        children: externalMobileMenuItems.map(function (menuItem) {
          return /*#__PURE__*/_jsxs(StyledLink, {
            onClick: menuItem.route === Routes.Profile ? onAuthClick(user) : menuItem.clickHandler,
            children: [/*#__PURE__*/_jsx(Typography, {
              color: "internationalOrange",
              variant: "button2",
              fontWeight: 500,
              textTransform: "unset",
              whiteSpace: "nowrap",
              children: menuItem.route === Routes.Profile ? user ? t('components.header.profile') : t('components.header.login') : menuItem.label
            }), /*#__PURE__*/_jsx(Icon, {
              src: right,
              width: 28,
              height: 28,
              color: "silverChalice"
            })]
          }, menuItem.label);
        })
      })]
    })]
  });
};

export { DrawerComponent };